// extracted by mini-css-extract-plugin
export var icon = "checklist-module--icon--f3463";
export var intro = "checklist-module--intro--8ed8d";
export var list = "checklist-module--list--96f64";
export var listItem = "checklist-module--listItem--99af4";